import React from "react";
import "./header.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const Footer = () => {
    const language = useSelector((state) => state.languagesState.languages);
    const location = useLocation();

    return (
        <div className="footer-div">
            <div className="flex-grow-1"></div>

            {location.pathname !== "/wizard" &&
                location.pathname !== "/leads-wizard" &&
                !location.pathname.includes("create-landing-page") &&
                !location.pathname.includes("landing-pages/edit") && (
                    <div className="footer-bottom d-flex flex-column">
                        <div className="d-flex align-items-center border-area">
                            <p className="m-0 copyright">
                                &copy; {new Date().getFullYear()} SignalSight
                            </p>
                            <p className="m-0 all_rights_reserved">
                                {language?.footer?.all_rights_reserved ??
                                    "All rights reserved"}
                            </p>
                        </div>
                        <div className="d-flex align-items-start title-area">
                            <p className="h5">
                                {language?.footer?.maximize_your ??
                                    "Maximize Your"}
                            </p>
                            <p className="h4">
                                {language?.footer?.marketing_powers ??
                                    "Marketing Powers"}
                            </p>
                        </div>
                    </div>
                )}
        </div>
    );
};

export default Footer;
